export default "__VITE_ASSET__22a92479__"